<template>
    <div style="width:100%;float:left;">
        <CCard>
            <CCardHeader @click="changeCollapsed()">Escape Order History
              <div class="card-header-actions">
                <CLink class="card-header-action btn-minimize">
                  <CIcon :name="`cil-chevron-${collapsed ? 'bottom' : 'top'}`"/>
                </CLink>
              </div>
            </CCardHeader>
            <CCollapse :show="collapsed" :duration="400">
              <CCardBody>
                  <div style="width:100%;text-align:center;float:left;">
                    <label>Search a customer to pull up their order history.</label><br />
                    <label style="color:red;">(We're still trying to load all of the PDFs that were from escape, so if you click to view the PDF and it's not there. Check back later and it might be there. When this message is gone that means all the PDFs should be loaded and good to go.)</label>
                    <input type="search" placeholder="Search Cust#, Name, or Log#.." class="form-control float-left searchInput" @keyup.enter="searchCustomer()" style="width:calc(100% - 75px);" v-model="customerSearch" />
                    <CButton size="sm" color="info" class="searchButton" @click="searchCustomer()">Search</CButton>
                  </div>
                  <div style="width:100%;float:left;margin-top:15px;" v-if="customerOptions">
                    <v-select
                      v-model="customer_selected"
                      v-if="customerOptions"
                      :options="customerOptions"
                      placeholder="Select Customer"
                      label="customer_number"
                      :filter-by="customerFilter"
                      item-value="customer_number"
                      @input="getData()"
                    >
                      <template slot="option" slot-scope="option">
                        {{option['customer_name']}} - {{option['customer_number']}}
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        {{option.customer_name}} - {{option.customer_number}}
                      </template>
                    </v-select>
                  </div>
                  <div style="width:100%;float:left;margin-top:15px;" v-if="customerOptions">
                    <input type="search" placeholder="Search Log# or CC# (if you would like to narrow it down)" class="form-control float-left searchInput" @keyup.enter="getData()" style="width:calc(100% - 75px);" v-model="logSearch" />
                    <CButton size="sm" color="info" class="searchButton" @click="getData()">Submit</CButton>
                  </div>
                  <spacer />
                  <div style="width:100%;float:left;" v-if="items">
                    <CDataTable
                        :items="items"
                        :fields="fields"
                        :items-per-page="perPage"
                        :pagination="paginationProps"
                        v-if="items && items.length > 0"
                    >
                        <!-- Define a template for the View PDF button column -->
                        <template #viewPdf="{item}">
                            <td>
                                <CButton size="sm" color="info" @click="viewPdf(item)">View PDF</CButton>
                            </td>
                        </template>
                    </CDataTable>
                    <div v-if="totalPages > 1" class="pagination">
                        <button @click="prevPage" :disabled="currentPage === 1">Prev</button>
                        <span>{{ currentPage }} / {{ totalPages }}</span>
                        <button @click="nextPage" :disabled="currentPage === totalPages">Next</button>
                    </div>
                  </div>
              </CCardBody>
            </CCollapse>
        </CCard>
        <div v-if="showPdfViewer">
            <div class="pdf-container">
                <order-history-pdf-viewer v-if="oldOrderItem" :oldOrderItem="oldOrderItem" :oldOrder="true" @closed="showPdfViewer = false" />
                <p v-else>No PDF data available.</p>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { CButton } from '@coreui/vue';
import OrderHistoryPdfViewer from './order_history_pdf_viewer';
var methods = {}

methods.getData = function () {
    this.searchLoading = true;
    if (this.customer_selected) {
        axios.get(this.$apiAdress + '/api/orderHistory?customer='+this.customer_selected.customer_number+'&page=' + this.currentPage + '&logSearch=' + this.logSearch)
        .then(response => {
            this.items = response.data.orderHistories;
            this.totalPages = response.data.totalPages;
        })
        .catch(error => {
            console.error('Error fetching order histories:', error);
        })
        .finally(() => {
            this.searchLoading = false;
        });
    }
}

methods.searchCustomer = function () {
  this.customerLoading = true
  this.customerOptions = null
  const postData = {
    search: this.customerSearch
  }
  axios.post(this.$apiAdress + '/api/searchCustomers?token='+localStorage.getItem('api_token'), postData).then(response => {
 
    this.customerOptions = []
    var that = this
    response.data.forEach(function (val) {
      var obj = {}
      for (var key in val) {
        obj[key] = val[key]
      }
      obj.label = val.customer_name + ' - ' + val.customer_number
      obj.id = val.customer_number
      that.customerOptions.push(obj)
    })
    if (this.customerOptions.length === 1) {
      this.customer_selected = this.customerOptions[0]
      this.getData()
    }
    this.customerLoading = false
  })
}

methods.nextPage = function () {
    if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getData();
    }
}

methods.prevPage = function () {
    if (this.currentPage > 1) {
        this.currentPage--;
        this.getData();
    }
}

methods.viewPdf = function (item) {
    this.oldOrderItem = item;
    this.showPdfViewer = true; // Show the PDF viewer
    console.log('View PDF')
    console.log(item)
}

methods.closePdfViewer = function () {
    this.showPdfViewer = false; // Close the PDF viewer
}

methods.changeCollapsed = function () {
  this.collapsed = !this.collapsed
  if (this.collapsed) {
    // this.getOrders()
  }
}

export default {
    name: "OrderHistory",
    props: ['customer'],
    components: {
        CButton,
        OrderHistoryPdfViewer
    },
    data() {
        return {
            items: [],
            customer_selected: '',
            customerOptions: '',
            customerLoading: false,
            logSearch: '',
            customerSearch: '',
            collapsed: false,
            fields: [
                'log_number',
                'customer_number',
                'ship_to_number',
                'cc_number',
                'order_date',
                { key: 'viewPdf', label: '', sortable: false }
            ],
            perPage: 30,
            paginationProps: {
                align: 'center',
                doubleArrows: false,
                previousButtonHtml: 'prev',
                nextButtonHtml: 'next'
            },
            customerFilter: (option, label, search) => {
              let temp = search.toLowerCase();
          
              return option.customer_name.toLowerCase().indexOf(temp) > -1 || 
              option.customer_number.toLowerCase().indexOf(temp) > -1
            },
            currentPage: 1,
            totalPages: 1,
            oldOrderItem: '',
            searchLoading: false,
            pdfData: null,
            showPdfViewer: false // Control the visibility of PDF viewer
        };
    },
    methods: methods,
    mounted() {
        // this.getData();
    }
};
</script>

<style scoped>
:host {
    height: 100vh;
    display: block;
    overflow: auto;
}

.pdf-container {
    height: calc(100vh - 70px);
    overflow: hidden;
}
</style>
